var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-circle',{attrs:{"fill":"#606266","stroke-width":0}})}
var staticRenderFns = []

export { render, staticRenderFns }